"use client"

import { getNonUmbracoUrl } from "@/utils"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import ButtonWithArrow from "../common/bit/ButtonWithArrow"
import CommonTitle from "../common/bit/CommonTitle"
import BlockWrapper from "../common/BlockWrapper"
import CircleImageCardListSwiperMobile from "../common/CircleImageCardListMobile"

const StyledButtonWithArrow = styled(ButtonWithArrow)`
  margin: 0 auto;
`
const StyledButtonWrapper = styled(Box)``

const CardsBoxImageWithIconListBlock = ({ data, id }: any) => {
  const { title, itemsList, button, subtitle, backgroundColor } = data

  return (
    <BlockWrapper id={id} bgColor={backgroundColor?.value}>
      <CommonTitle title={title?.value} subtitle={subtitle?.value} />
      {itemsList?.blocks && (
        <CircleImageCardListSwiperMobile itemsList={itemsList} />
      )}
      {button && button?.links[0] && (
        <StyledButtonWrapper>
          <StyledButtonWithArrow href={getNonUmbracoUrl(button?.links[0]?.url)}>
            {button.links[0]?.name}
          </StyledButtonWithArrow>
        </StyledButtonWrapper>
      )}
    </BlockWrapper>
  )
}

export default CardsBoxImageWithIconListBlock
